import { ClearOutlined } from '@ant-design/icons';
import { Button, Collapse, Divider, Form, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import Search from 'antd/lib/input/Search';
import { offerTypeText } from 'components/BusinessLogic/Product/OfferTypeText';
import { CommercialGroup, Product } from 'model';
import Producer from 'model/Producer';
import ProductColor from 'model/ProductColor';
import { ProductOfferFilterParam } from 'model/types';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getFilterState,
  getOfferTypeProductList,
  setFilterState,
  setOfferTypeProductList,
  setPageProductList,
} from 'services/config';
import { useGetOfferFiltersQuery } from 'services/ecommerceApi';
import { getShowPinnedFilter } from 'store/state/offerFilters/offerFiltersSelectors';
import { offerFiltersSelectors, sessionSelectors } from 'store/state/selectors';
import { offerFiltersActions } from 'store/state/slices';
import { RootState } from 'store/store';
import { Loader } from '../../Wired/DefaultLoader/styles';
import {
  CheckboxComponent,
  CheckboxGroup,
  Container,
  ContentClean,
  GroupSelectAndDeselect,
  SpanSelectAllAndDeselectAll,
} from './styles';

const { Panel } = Collapse;

export default function NewFilter() {
  const [form] = useForm();
  const dispatch = useDispatch();
  const deliveryDate = useSelector(sessionSelectors.getSelectedDeliveryDate);
  const isProducerAuthenticated = useSelector(
    sessionSelectors.isProducerAuthenticated,
  );
  const customerId = useSelector(sessionSelectors.getSelectedCustomerId);
  const businessDate = useSelector(sessionSelectors.getSelectedBillingDate);
  const siteId = useSelector(sessionSelectors.getSitesIds);
  const producerUrl = useSelector(sessionSelectors.getProducerUrl);
  const isAuthenticated = useSelector(sessionSelectors.getAuthenticated);
  const filterByHeader = useSelector(offerFiltersSelectors.getFilterByHeader);
  const { name: filterName } = useSelector(
    offerFiltersSelectors.getOfferFilters,
  );
  const showPinnedFilter = useSelector(getShowPinnedFilter);
  const { data, isLoading, isFetching } = useGetOfferFiltersQuery({
    customerId,
    deliveryDate,
    businessDate,
    siteId,
    ...filterByHeader,
  });

  const [filteredProducts, setFilteredProducts] = useState<Product[]>([]);
  const [filteredCommercialGroupIds, setFilteredCommercialGroupIds] = useState<
    CommercialGroup[]
  >([]);
  const [filteredDimensions, setFilteredDimensions] = useState<string[]>([]);
  const [filteredColors, setFilteredColors] = useState<ProductColor[]>([]);
  const [filteredSites, setFilteredSites] = useState<Producer[]>([]);
  const [changeFilter, setChangeFilter] = useState<boolean>(false);

  const [selectedCategories, setSelectedCategories] = useState<number[]>([]);
  const [selectedOfferTypes, setSelectedOfferTypes] = useState<string[]>(
    getOfferTypeProductList()?.length > 0 ? getOfferTypeProductList() : [],
  );
  const [selectedCommercialGroupIds, setSelectedCommercialGroupIds] = useState<
    number[]
  >([]);
  const [selectedProducts, setSelectedProducts] = useState<number[]>([]);
  const [selectedQualities, setSelectedQualities] = useState<string[]>([]);
  const [selectedColors, setSelectedColors] = useState<string[]>([]);
  const [selectedHeights, setSelectedHeights] = useState<string[]>([]);
  const [selectedDimensions, setSelectedDimensions] = useState<string[]>([]);
  const [selectedSites, setSelectedSites] = useState<number[]>([]);
  const [selectedImageTypes, setSelectedImageTypes] = useState<string[]>([]);
  const [productSearchTerm, setProductSearchTerm] = useState<string>('');
  const [commercialGroupSearchTerm, setCommercialGroupSearchTerm] =
    useState<string>('');
  const clearFilterStatus = useSelector(offerFiltersSelectors.getClearFilter);
  const { offerTypes: offerType = [], categories: categoriesFilter = [] } =
    useSelector((state: RootState) => state.offerFilters);

  function createCheckboxRecord(value: number | string, label: string) {
    return {
      value,
      label,
      checked: true,
      onchange: () => console.log('Teste'),
    };
  }

  useEffect(() => {
    if (offerType?.length && offerType !== selectedOfferTypes) {
      setChangeFilter(false);
      setSelectedOfferTypes(offerType);
    }
  }, [offerType]);

  useEffect(() => {
    if (categoriesFilter?.length && categoriesFilter !== selectedCategories) {
      setChangeFilter(false);
      setSelectedCategories(categoriesFilter);
    }
  }, [categoriesFilter]);

  const deselectAllSite = useCallback(() => {
    form.setFieldsValue({ inputSite: '' });
    filterSitesInList('');
    if (filteredSites?.length) {
      const arrayAux = filteredSites?.map((producer) => producer.id);
      filterSites(
        selectedSites.filter((producerId) => !arrayAux.includes(producerId)),
      );
    }
  }, [selectedSites, filteredSites]);

  const deselectAllCommercialGroupIds = useCallback(() => {
    form.setFieldsValue({ commercialGroupIds: '' });
    filterCommercialGroupIdsInList('');
    if (filteredCommercialGroupIds?.length) {
      const arrayAux: number[] = filteredCommercialGroupIds?.map(
        (option) => option.id,
      );
      filterCommercialGroupIds(
        selectedCommercialGroupIds.filter(
          (commercialGroupId) => !arrayAux.includes(commercialGroupId),
        ),
      );
    }
  }, [selectedCommercialGroupIds, filteredCommercialGroupIds]);

  const deselectAllProducts = useCallback(() => {
    form.setFieldsValue({ inputProducts: '' });
    filterProductInList('');
    if (filteredProducts?.length) {
      const arrayAux: number[] = filteredProducts?.map((option) => option.id);
      filterProducts(
        selectedProducts.filter((productsId) => !arrayAux.includes(productsId)),
      );
    }
  }, [selectedProducts, filteredProducts]);

  const deselectAllColors = useCallback(() => {
    form.setFieldsValue({ inputColors: '' });
    filterColorsInList('');
    if (filteredColors?.length) {
      const arrayAux: string[] = filteredColors?.map((option) =>
        String(option.id),
      );
      filterColors(
        selectedColors.filter((colorId) => !arrayAux.includes(colorId)),
      );
    }
  }, [selectedColors, filteredColors]);

  const deselectAllDimensions = useCallback(() => {
    form.setFieldsValue({ inputDimensions: '' });
    filterDimensionsInList('');
    if (filteredDimensions?.length) {
      filterDimensions(
        selectedDimensions.filter(
          (dimension) => !filteredDimensions.includes(dimension),
        ),
      );
    }
  }, [selectedDimensions, filteredDimensions]);

  const filterCategories = useCallback((checkedValues) => {
    setSelectedCategories(checkedValues);
    setTimeout(() => {
      setChangeFilter(true);
    }, 0);
  }, []);

  const filterOfferTypes = useCallback((checkedValues) => {
    setSelectedOfferTypes(checkedValues);
    setOfferTypeProductList([]);
    setTimeout(() => {
      setChangeFilter(true);
    }, 0);
  }, []);

  const filterCommercialGroupIds = useCallback((checkedValues) => {
    if (Array.isArray(checkedValues)) {
      setSelectedCommercialGroupIds(checkedValues);
    } else {
      setSelectedCommercialGroupIds((values) =>
        values.find((value) => +value === +checkedValues)
          ? values.filter((value) => +value !== +checkedValues)
          : [...values, ...[checkedValues]],
      );
    }
    setTimeout(() => {
      setChangeFilter(true);
    }, 0);
  }, []);

  const filterProducts = useCallback((checkedValues) => {
    if (Array.isArray(checkedValues)) {
      setSelectedProducts(checkedValues);
    } else {
      setSelectedProducts((values) =>
        values.find((value) => +value === +checkedValues)
          ? values.filter((value) => +value !== +checkedValues)
          : [...values, ...[checkedValues]],
      );
    }
    setTimeout(() => {
      setChangeFilter(true);
    }, 0);
  }, []);

  const filterQualities = useCallback((checkedValues) => {
    setSelectedQualities(checkedValues);
    setTimeout(() => {
      setChangeFilter(true);
    }, 0);
  }, []);

  const filterImageTypes = useCallback((checkedValues) => {
    setSelectedImageTypes(checkedValues);
    setTimeout(() => {
      setChangeFilter(true);
    }, 0);
  }, []);

  const filterColors = useCallback((checkedValues) => {
    if (Array.isArray(checkedValues)) {
      setSelectedColors(checkedValues);
    } else {
      setSelectedColors((values) =>
        values.find((value) => value === checkedValues)
          ? values.filter((value) => value !== checkedValues)
          : [...values, ...[checkedValues]],
      );
    }
    setTimeout(() => {
      setChangeFilter(true);
    }, 0);
  }, []);

  const filterDimensions = useCallback((checkedValues) => {
    if (Array.isArray(checkedValues)) {
      setSelectedDimensions(checkedValues);
    } else {
      setSelectedDimensions((values) =>
        values.find((value) => value === checkedValues)
          ? values.filter((value) => value !== checkedValues)
          : [...values, ...[checkedValues]],
      );
    }
    setTimeout(() => {
      setChangeFilter(true);
    }, 0);
  }, []);

  const filterSites = useCallback((checkedValues) => {
    if (Array.isArray(checkedValues)) {
      setSelectedSites(checkedValues);
    } else {
      setSelectedSites((values) =>
        values.find((value) => +value === +checkedValues)
          ? values.filter((value) => +value !== +checkedValues)
          : [...values, ...[checkedValues]],
      );
    }
    setTimeout(() => {
      setChangeFilter(true);
    }, 0);
  }, []);

  const searchProducts = useCallback(() => {
    dispatch(
      offerFiltersActions.filter({
        name: filterName,
        categories: selectedCategories,
        offerTypes: selectedOfferTypes,
        productsIds: selectedProducts,
        commercialGroupIds: selectedCommercialGroupIds,
        qualities: selectedQualities,
        colors: selectedColors,
        heights: selectedHeights,
        dimensions: selectedDimensions,
        siteId: selectedSites,
        imageTypes: selectedImageTypes.length > 0 ? selectedImageTypes : undefined,
      }),
    );
    setFilterState({
      name: filterName,
      categories: selectedCategories,
      offerTypes: selectedOfferTypes,
      productsIds: selectedProducts,
      commercialGroupIds: selectedCommercialGroupIds,
      qualities: selectedQualities,
      colors: selectedColors,
      heights: selectedHeights,
      dimensions: selectedDimensions,
      siteId: selectedSites,
      imageTypes: selectedImageTypes.length > 0 ? selectedImageTypes : undefined,
    });
    setPageProductList(1);
  }, [
    filterName,
    dispatch,
    selectedCategories,
    selectedOfferTypes,
    selectedProducts,
    selectedQualities,
    selectedColors,
    selectedHeights,
    selectedCommercialGroupIds,
    selectedDimensions,
    selectedSites,
    selectedImageTypes,
  ]);

  useEffect(() => {
    if (changeFilter) {
      searchProducts();
      setChangeFilter(false);
    }
  }, [changeFilter, searchProducts]);

  const clearFilter = (filter: boolean) => {
    form.resetFields();
    filterSitesInList('');
    filterProductInList('');
    filterCommercialGroupIdsInList('');
    filterDimensionsInList('');
    filterColorsInList('');

    if (filter) {
      dispatch(offerFiltersActions.clear());
      setSelectedCategories([]);
      setSelectedColors([]);
      setSelectedDimensions([]);
      setSelectedHeights([]);
      setSelectedOfferTypes([]);
      setSelectedSites(producerUrl === 'veiling' ? [] : siteId);
      setSelectedProducts([]);
      setSelectedCommercialGroupIds([]);
      setSelectedQualities([]);
      setSelectedImageTypes([]);
      setFilterState({
        categories: [],
        offerTypes: [],
        productsIds: [],
        commercialGroupIds: [],
        qualities: [],
        colors: [],
        heights: [],
        dimensions: [],
        producerIds: [],
        siteId: producerUrl === 'veiling' ? [] : siteId,
        imageTypes: [],
      });
      setOfferTypeProductList([]);
      setPageProductList(1);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
    categories,
    offerTypes,
    products,
    commercialGroups,
    qualities,
    colors,
    sites,
    dimensions,
  } = data ?? {};

  useEffect(() => {
    if (products && products.length > 0) {
      setFilteredProducts(products);
    }
  }, [products]);

  useEffect(() => {
    if (commercialGroups && commercialGroups.length > 0) {
      setFilteredCommercialGroupIds(commercialGroups);
    }
  }, [commercialGroups]);

  useEffect(() => {
    const filterState = getFilterState() as ProductOfferFilterParam;
    setSelectedCategories(filterState?.categories ?? []);
    setSelectedColors(filterState?.colors ?? []);
    setSelectedDimensions(filterState?.dimensions ?? []);
    setSelectedHeights(filterState?.heights ?? []);
    if (!getOfferTypeProductList() || !!getOfferTypeProductList().length) {
      setSelectedOfferTypes(filterState?.offerTypes ?? []);
    }
    setSelectedSites(filterState?.siteId ?? []);
    setSelectedProducts(filterState?.productsIds ?? []);
    setSelectedCommercialGroupIds(filterState?.commercialGroupIds ?? []);
    setSelectedQualities(filterState?.qualities ?? []);
    setSelectedImageTypes(filterState?.imageTypes ?? []);
  }, []);

  useEffect(() => {
    const filterState = getFilterState() as ProductOfferFilterParam;
    setSelectedCategories(filterState?.categories ?? []);
    setSelectedColors(filterState?.colors ?? []);
    setSelectedDimensions(filterState?.dimensions ?? []);
    setSelectedHeights(filterState?.heights ?? []);
    if (!getOfferTypeProductList() || !!getOfferTypeProductList().length) {
      setSelectedOfferTypes(filterState?.offerTypes ?? []);
    }
    setSelectedSites(filterState?.siteId ?? []);
    setSelectedProducts(filterState?.productsIds ?? []);
    setSelectedCommercialGroupIds(filterState?.commercialGroupIds ?? []);
    setSelectedQualities(filterState?.qualities ?? []);
    setSelectedImageTypes(filterState?.imageTypes ?? []);
  }, [showPinnedFilter]);

  useEffect(() => {
    if (dimensions && dimensions.length > 0) {
      setFilteredDimensions(dimensions);
    }
  }, [dimensions]);

  useEffect(() => {
    if (clearFilterStatus) {
      dispatch(offerFiltersActions.setClearFilter(false));
      clearFilter(true);
    }
  }, [clearFilterStatus]);

  useEffect(() => {
    if (colors && colors.length > 0) {
      setFilteredColors(colors);
    }
  }, [colors]);

  useEffect(() => {
    if (sites && sites.length > 0) {
      setFilteredSites(sites);
    }
  }, [sites]);

  const filterCommercialGroupIdsInList = useCallback(
    (term: string) => {
      setCommercialGroupSearchTerm(term);
      if (!commercialGroups) return;
      if (!term.length) {
        setFilteredCommercialGroupIds(commercialGroups);
        return;
      }
      setFilteredCommercialGroupIds(
        commercialGroups.filter((commercialGroup) =>
          commercialGroup.name.toUpperCase().startsWith(term.toUpperCase()),
        ),
      );
    },
    [filteredCommercialGroupIds, commercialGroups],
  );

  const filterProductInList = useCallback(
    (term: string) => {
      setProductSearchTerm(term);
      if (!products) return;
      if (!term.length) {
        setFilteredProducts(products);
        return;
      }
      setFilteredProducts(
        products.filter((product) =>
          product.name.toUpperCase().includes(term.toUpperCase()),
        ),
      );
    },
    [filteredProducts, products],
  );

  const filterDimensionsInList = useCallback(
    (term: string) => {
      if (!dimensions) return;
      if (!term.length) {
        setFilteredDimensions(dimensions);
        return;
      }
      setFilteredDimensions(
        dimensions.filter((dimension) =>
          dimension.toUpperCase().startsWith(term.toUpperCase()),
        ),
      );
    },
    [filteredProducts, products],
  );

  const filterSitesInList = useCallback(
    (term: string) => {
      if (!sites) return;
      if (!term.length) {
        setFilteredSites(sites);
        return;
      }
      setFilteredSites(
        sites.filter((site) =>
          site.name.toUpperCase().includes(term.toUpperCase()),
        ),
      );
    },
    [filteredSites, sites],
  );

  const filterColorsInList = useCallback(
    (term: string) => {
      if (!colors) return;
      if (!term.length) {
        setFilteredColors(colors);
        return;
      }
      setFilteredColors(
        colors.filter((color) =>
          color.name.toUpperCase().startsWith(term.toUpperCase()),
        ),
      );
    },
    [filteredColors, colors],
  );

  const allFilteredProductsSelected =
    filteredProducts.length > 0 &&
    filteredProducts.every(
      ({ id }) => !!selectedProducts.find((x) => +x === +id),
    );

  const allFilteredCommercialGroupsSelected =
    filteredCommercialGroupIds.length > 0 &&
    filteredCommercialGroupIds.every(
      ({ id }) => !!selectedCommercialGroupIds.find((x) => +x === +id),
    );

  const toggleSelectAllProducts = useCallback(() => {
    const filteredIds = filteredProducts.map(({ id }) => id);
    if (!allFilteredProductsSelected) {
      const merged = new Set(selectedProducts.map(Number));
      filteredIds.forEach((id) => merged.add(Number(id)));
      filterProducts(Array.from(merged));
      return;
    }
    filterProducts(
      selectedProducts.filter(
        (id) => !filteredIds.find((filteredId) => +filteredId === +id),
      ),
    );
  }, [
    allFilteredProductsSelected,
    filteredProducts,
    selectedProducts,
    filterProducts,
  ]);

  const toggleSelectAllCommercialGroups = useCallback(() => {
    const filteredIds = filteredCommercialGroupIds.map(({ id }) => id);
    if (!allFilteredCommercialGroupsSelected) {
      const merged = new Set(selectedCommercialGroupIds.map(Number));
      filteredIds.forEach((id) => merged.add(Number(id)));
      filterCommercialGroupIds(Array.from(merged));
      return;
    }
    filterCommercialGroupIds(
      selectedCommercialGroupIds.filter(
        (id) => !filteredIds.find((filteredId) => +filteredId === +id),
      ),
    );
  }, [
    allFilteredCommercialGroupsSelected,
    filteredCommercialGroupIds,
    selectedCommercialGroupIds,
    filterCommercialGroupIds,
  ]);

  return (
    <Container className="new-filter-pinned">
      <Form form={form}>
        {isAuthenticated && (
          <>
            <Collapse ghost className="collapse-drawer-filter">
              <Panel header="TIPO DE OFERTA" key="2">
                {offerTypes ? (
                  <CheckboxGroup
                    onChange={filterOfferTypes}
                    options={offerTypes
                      ?.concat(['directed'])
                      ?.map((offerType) =>
                        createCheckboxRecord(
                          offerType,
                          offerTypeText[offerType],
                        ),
                      )}
                    value={selectedOfferTypes}
                  />
                ) : (
                  <div />
                )}
                {selectedOfferTypes.length > 0 && (
                  <GroupSelectAndDeselect>
                    <SpanSelectAllAndDeselectAll
                      onClick={() => {
                        setSelectedOfferTypes([]);
                        setOfferTypeProductList([]);
                        setTimeout(() => {
                          setChangeFilter(true);
                        }, 0);
                      }}
                    >
                      Limpar
                    </SpanSelectAllAndDeselectAll>
                  </GroupSelectAndDeselect>
                )}
              </Panel>
            </Collapse>
            <Divider />
          </>
        )}

        <Collapse ghost className="collapse-drawer-filter">
          <Panel header="TIPO DE IMAGEM" key="11">
            <div className="group-options-filters">
              <CheckboxGroup
                onChange={filterImageTypes}
                options={[
                  { value: 'realImage', label: 'Foto Real' },
                  { value: 'defaultImage', label: 'Foto Padrão' },
                ]}
                value={selectedImageTypes}
              />
            </div>
            {selectedImageTypes.length > 0 && (
              <GroupSelectAndDeselect>
                <SpanSelectAllAndDeselectAll
                  onClick={() => filterImageTypes([])}
                >
                  Limpar
                </SpanSelectAllAndDeselectAll>
              </GroupSelectAndDeselect>
            )}
          </Panel>
        </Collapse>

        <Divider />

        {(producerUrl === 'veiling' ||
          !producerUrl ||
          isProducerAuthenticated) && (
          <>
            <Collapse ghost className="collapse-drawer-filter">
              <Panel header="PRODUTORES" key="8">
                <Form.Item name="inputSite">
                  <Search
                    onChange={(event) => filterSitesInList(event.target.value)}
                  />
                </Form.Item>
                <div className="group-options-filters">
                  {filteredSites ? (
                    filteredSites?.map(({ id, name }) => (
                      <CheckboxComponent
                        onChange={(event) => filterSites(event.target.value)}
                        name={name}
                        key={`checkbox-sites-${id}-${name}`}
                        value={id}
                        checked={!!selectedSites.find((x) => +x === +id)}
                      >
                        {name}
                      </CheckboxComponent>
                    ))
                  ) : (
                    <div />
                  )}
                </div>
                {(form.getFieldValue('inputSite')?.length >= 3 ||
                  selectedSites) && (
                  <GroupSelectAndDeselect>
                    {selectedSites?.length > 0 && (
                      <SpanSelectAllAndDeselectAll onClick={deselectAllSite}>
                        Limpar
                      </SpanSelectAllAndDeselectAll>
                    )}
                  </GroupSelectAndDeselect>
                )}
              </Panel>
            </Collapse>
            <Divider />
          </>
        )}
        <Collapse ghost className="collapse-drawer-filter">
          <Panel header="CATEGORIA DE PRODUTO" key="1">
            <div className="group-options-filters">
              {categories ? (
                <CheckboxGroup
                  onChange={filterCategories}
                  options={categories?.map(({ id, name }) =>
                    createCheckboxRecord(+id, name),
                  )}
                  value={selectedCategories}
                />
              ) : (
                <div />
              )}
            </div>
            {(form.getFieldValue('inputCategories')?.length >= 3 ||
              selectedCategories.length > 0) && (
              <GroupSelectAndDeselect>
                {selectedCategories.length > 0 && (
                  <SpanSelectAllAndDeselectAll
                    onClick={() => filterCategories([])}
                  >
                    Limpar
                  </SpanSelectAllAndDeselectAll>
                )}
              </GroupSelectAndDeselect>
            )}
          </Panel>
        </Collapse>

        <Divider />

        <Collapse ghost className="collapse-drawer-filter">
          <Panel header="GRUPO DE PRODUTOS" key="10">
            <Form.Item name="commercialGroupIds">
              <Search
                onChange={(event) =>
                  filterCommercialGroupIdsInList(event.target.value)
                }
              />
            </Form.Item>
            {filteredCommercialGroupIds.length > 0 && (
              <CheckboxComponent
                checked={allFilteredCommercialGroupsSelected}
                onChange={toggleSelectAllCommercialGroups}
                value="select-all-commercial-groups"
                name="select-all-commercial-groups"
              >
                Selecionar todos
              </CheckboxComponent>
            )}
            <div className="group-options-filters">
              {filteredCommercialGroupIds ? (
                filteredCommercialGroupIds?.map(({ id, name }) => (
                  <CheckboxComponent
                    onChange={(event) =>
                      filterCommercialGroupIds(event.target.value)
                    }
                    name={name}
                    key={`checkbox-filteredCommercialGroupIds-${id}-${name}`}
                    value={id}
                    checked={
                      !!selectedCommercialGroupIds.find((x) => +x === +id)
                    }
                  >
                    {name}
                  </CheckboxComponent>
                ))
              ) : (
                <div />
              )}
            </div>
            {(form.getFieldValue('commercialGroupIds')?.length >= 3 ||
              selectedCommercialGroupIds) && (
              <GroupSelectAndDeselect>
                {selectedCommercialGroupIds?.length > 0 && (
                  <SpanSelectAllAndDeselectAll
                    onClick={deselectAllCommercialGroupIds}
                  >
                    Limpar
                  </SpanSelectAllAndDeselectAll>
                )}
              </GroupSelectAndDeselect>
            )}
          </Panel>
        </Collapse>

        <Divider />

        <Collapse ghost className="collapse-drawer-filter">
          <Panel header="PRODUTO" key="3">
            <Form.Item name="inputProducts">
              <Search
                onChange={(event) => filterProductInList(event.target.value)}
              />
            </Form.Item>
            {filteredProducts.length > 0 && (
              <CheckboxComponent
                checked={allFilteredProductsSelected}
                onChange={toggleSelectAllProducts}
                value="select-all-products"
                name="select-all-products"
              >
                Selecionar todos
              </CheckboxComponent>
            )}
            <div className="group-options-filters">
              {filteredProducts ? (
                filteredProducts?.map(({ id, name }) => (
                  <CheckboxComponent
                    onChange={(event) => filterProducts(event.target.value)}
                    name={name}
                    key={`checkbox-filteredProducts-${id}-${name}`}
                    value={id}
                    checked={!!selectedProducts.find((x) => +x === +id)}
                  >
                    {name}
                  </CheckboxComponent>
                ))
              ) : (
                <div />
              )}
            </div>
            {(form.getFieldValue('inputProducts')?.length >= 3 ||
              selectedProducts) && (
              <GroupSelectAndDeselect>
                {selectedProducts?.length > 0 && (
                  <SpanSelectAllAndDeselectAll onClick={deselectAllProducts}>
                    Limpar
                  </SpanSelectAllAndDeselectAll>
                )}
              </GroupSelectAndDeselect>
            )}
          </Panel>
        </Collapse>

        <Divider />

        <Collapse ghost className="collapse-drawer-filter">
          <Panel header="DIMENSÃO / ALTURA" key="7">
            <Form.Item name="inputDimensions">
              <Search
                onChange={(event) => filterDimensionsInList(event.target.value)}
              />
            </Form.Item>
            <div className="group-options-filters">
              {filteredDimensions ? (
                filteredDimensions?.map((dimension) => (
                  <CheckboxComponent
                    onChange={(event) => filterDimensions(event.target.value)}
                    name={dimension}
                    key={`checkbox-filteredDimensions-${dimension}`}
                    value={dimension}
                    checked={!!selectedDimensions.find((x) => x === dimension)}
                  >
                    {dimension}
                  </CheckboxComponent>
                ))
              ) : (
                <div />
              )}
            </div>
            {(form.getFieldValue('inputDimensions')?.length >= 3 ||
              selectedDimensions) && (
              <GroupSelectAndDeselect>
                {selectedDimensions?.length > 0 && (
                  <SpanSelectAllAndDeselectAll onClick={deselectAllDimensions}>
                    Limpar
                  </SpanSelectAllAndDeselectAll>
                )}
              </GroupSelectAndDeselect>
            )}
          </Panel>
        </Collapse>

        <Divider />

        <Collapse ghost className="collapse-drawer-filter">
          <Panel header="QUALIDADE" key="4">
            <div className="group-options-filters">
              {qualities ? (
                <CheckboxGroup
                  onChange={filterQualities}
                  options={qualities?.map(({ id, name }) =>
                    createCheckboxRecord(String(id), name),
                  )}
                  value={selectedQualities}
                />
              ) : (
                <div />
              )}
            </div>
            {selectedQualities.length > 0 && (
              <GroupSelectAndDeselect>
                <SpanSelectAllAndDeselectAll onClick={() => filterQualities([])}>
                  Limpar
                </SpanSelectAllAndDeselectAll>
              </GroupSelectAndDeselect>
            )}
          </Panel>
        </Collapse>

        <Divider />

        <Collapse ghost className="collapse-drawer-filter">
          <Panel header="COR" key="5">
            <Form.Item name="inputColors">
              <Search
                onChange={(event) => filterColorsInList(event.target.value)}
              />
            </Form.Item>
            <div className="group-options-filters">
              {filteredColors ? (
                filteredColors?.map(({ id, name }) => (
                  <CheckboxComponent
                    onChange={(event) => filterColors(event.target.value)}
                    name={name}
                    key={`checkbox-filteredColors-${name}-${String(id)}`}
                    value={String(id)}
                    checked={!!selectedColors.find((x) => x === String(id))}
                  >
                    {name}
                  </CheckboxComponent>
                ))
              ) : (
                <div />
              )}
            </div>
            {(form.getFieldValue('inputColors')?.length >= 3 ||
              selectedColors) && (
              <GroupSelectAndDeselect>
                {selectedColors?.length > 0 && (
                  <SpanSelectAllAndDeselectAll onClick={deselectAllColors}>
                    Limpar
                  </SpanSelectAllAndDeselectAll>
                )}
              </GroupSelectAndDeselect>
            )}
          </Panel>
        </Collapse>
        <ContentClean className="content-clean">
          <Row>
            <Button onClick={() => clearFilter(true)}>
              Limpar todos <ClearOutlined />
            </Button>
          </Row>
        </ContentClean>

        <Loader spinning={isLoading || isFetching} size="large" />
      </Form>
    </Container>
  );
}
